import { createRef, useMemo } from 'react';
import { TAuthSession } from '@/modules/auth/types';
import useData from '@/data/Data.hook';
import Crypto from '@/utils/crypto';

const passwordRef = createRef<string>();

export const useAuthCSRSession = () => {
  const { setData, data } = useData('session');

  const { encrypt, decrypt } = useMemo(() => {
    if (!passwordRef.current)
      (passwordRef as any).current = `${Date.now()}${Math.random()}`;
    return Crypto<TAuthSession>(passwordRef.current!);
  }, []);

  return {
    setSession: (data: TAuthSession): void => setData(encrypt(data)),
    getSession: (): TAuthSession => decrypt(data),
  };
};
